import { OAUTH_PROVIDERS } from '@drama/contracts/platform'

/** 各平台 client id 对应的环境变量名。 */
const CLIENT_ID_ENV_KEYS = {
  google: 'VITE_OAUTH_GOOGLE_CLIENT_ID',
  apple: 'VITE_OAUTH_APPLE_CLIENT_ID',
  x: 'VITE_OAUTH_X_CLIENT_ID',
  discord: 'VITE_OAUTH_DISCORD_CLIENT_ID',
  facebook: 'VITE_OAUTH_FACEBOOK_CLIENT_ID',
  tiktok: 'VITE_OAUTH_TIKTOK_CLIENT_ID',
}

/**
 * 按 `OAUTH_PROVIDERS` 顺序，取出本次构建已配置 client id 的平台。
 * @returns {{ provider: string, client_id: string }[]}
 */
export function configuredOauthClients() {
  // 必须写成字面的 import.meta.env，Vite 靠这个 token 做替换，包一层括号就替换不到
  const env = import.meta.env
  const clients = []
  for (const provider of OAUTH_PROVIDERS) {
    const client_id = env[CLIENT_ID_ENV_KEYS[provider]] || ''
    if (client_id) clients.push({ provider, client_id })
  }
  return clients
}
